/* eslint no-unused-vars: */
import React from "react";
import { Column } from "material-table";
import moment from "moment";
import { currencyTHB } from "../../../../utils/formatCurrency";

export const getColumnsTableReport = ({ handleClickViewOrder, options }) => {
    const paymentColumns = options?.payment?.reduce((result, payment) => {
        result[payment?.paymentMethodId] = payment?.name;
        return result;
    }, {});

    /** @type Column */
    const column = [
        {
            field: "date",
            title: "Order Date",
            render: rowData => moment(rowData?.date, "YYYY-MM-DD").format("DD/MM/YYYY"),
        },
        {
            field: "name",
            title: "Branch",
        },
        {
            field: "totalTransaction",
            title: "Transaction",
            render: rowData => {
                return (
                    <div style={{ cursor: "pointer" }} onClick={() => handleClickViewOrder(rowData, "transaction")}>
                        <strong>{rowData?.totalTransaction}</strong>
                    </div>
                );
            },
        },
        {
            field: "sales",
            title: "Sales Total",
            render: rowData => {
                return (
                    <div style={{ cursor: "pointer" }} onClick={() => handleClickViewOrder(rowData, "sales")}>
                        <strong>{currencyTHB(rowData?.sales)}</strong>
                    </div>
                );
            },
        },
        {
            field: "package",
            title: paymentColumns?.[5] || "Package",
            render: rowData => {
                return (
                    <div style={{ cursor: "pointer" }} onClick={() => handleClickViewOrder(rowData, "package")}>
                        <strong>{currencyTHB(rowData?.package)}</strong>
                    </div>
                );
            },
        },
        {
            field: "scb",
            title: paymentColumns?.[6] || "SCB",
            render: rowData => {
                return (
                    <div style={{ cursor: "pointer" }} onClick={() => handleClickViewOrder(rowData, "scb")}>
                        <strong>{currencyTHB(rowData?.scb)}</strong>
                    </div>
                );
            },
        },
        {
            field: "kbank",
            title: paymentColumns?.[7] || "K Bank",
            render: rowData => {
                return (
                    <div style={{ cursor: "pointer" }} onClick={() => handleClickViewOrder(rowData, "kbank")}>
                        <strong>{currencyTHB(rowData?.kbank)}</strong>
                    </div>
                );
            },
        },
        {
            field: "bay",
            title: paymentColumns?.[8] || "BAY",
            render: rowData => {
                return (
                    <div style={{ cursor: "pointer" }} onClick={() => handleClickViewOrder(rowData, "bay")}>
                        <strong>{currencyTHB(rowData?.bay)}</strong>
                    </div>
                );
            },
        },
        {
            field: "credit",
            title: paymentColumns?.[3] || "Credit card",
            render: rowData => {
                return (
                    <div style={{ cursor: "pointer" }} onClick={() => handleClickViewOrder(rowData, "credit")}>
                        <strong>{currencyTHB(rowData?.credit)}</strong>
                    </div>
                );
            },
        },
        {
            field: "kshop",
            title: paymentColumns?.[9] || "Kshop",
            render: rowData => {
                return (
                    <div style={{ cursor: "pointer" }} onClick={() => handleClickViewOrder(rowData, "kshop")}>
                        <strong>{currencyTHB(rowData?.kshop)}</strong>
                    </div>
                );
            },
        },
        {
            field: "installment",
            title: paymentColumns?.[10] || "ผ่อนผ่านบัตร",
            render: rowData => {
                return (
                    <div style={{ cursor: "pointer" }} onClick={() => handleClickViewOrder(rowData, "installment")}>
                        <strong>{currencyTHB(rowData?.installment)}</strong>
                    </div>
                );
            },
        },
        {
            field: "ttb",
            title: paymentColumns?.[11] || "TTB",
            render: rowData => {
                return (
                    <div style={{ cursor: "pointer" }} onClick={() => handleClickViewOrder(rowData, "ttb")}>
                        <strong>{currencyTHB(rowData?.ttb)}</strong>
                    </div>
                );
            },
        },
        {
            field: "paypal",
            title: paymentColumns?.[12] || "PAYPAL",
            render: rowData => {
                return (
                    <div style={{ cursor: "pointer" }} onClick={() => handleClickViewOrder(rowData, "paypal")}>
                        <strong>{currencyTHB(rowData?.paypal)}</strong>
                    </div>
                );
            },
        },
        {
            field: "uob",
            title: paymentColumns?.[13] || "UOB",
            render: rowData => {
                return (
                    <div style={{ cursor: "pointer" }} onClick={() => handleClickViewOrder(rowData, "uob")}>
                        <strong>{currencyTHB(rowData?.uob)}</strong>
                    </div>
                );
            },
        },
        {
            field: "cash",
            title: paymentColumns?.[1] || "Cash",
            render: rowData => {
                return (
                    <div style={{ cursor: "pointer" }} onClick={() => handleClickViewOrder(rowData, "cash")}>
                        <strong>{currencyTHB(rowData?.cash)}</strong>
                    </div>
                );
            },
        },
        {
            field: "transfer",
            title: paymentColumns?.[2] || "Transfer",
            render: rowData => {
                return (
                    <div style={{ cursor: "pointer" }} onClick={() => handleClickViewOrder(rowData, "transfer")}>
                        <strong>{currencyTHB(rowData?.transfer)}</strong>
                    </div>
                );
            },
        },
        {
            field: "other",
            title: paymentColumns?.[4] || "Other",
            render: rowData => {
                return (
                    <div style={{ cursor: "pointer" }} onClick={() => handleClickViewOrder(rowData, "other")}>
                        <strong>{currencyTHB(rowData?.other)}</strong>
                    </div>
                );
            },
        },
    ];
    const data = column?.map((col, index) => ({
        ...col,
        cellStyle: { textAlign: "center" },
    }));
    return data;
};
